export default {
  data () {
    return {
      states: {
        horHelperLine: null,
        verHelperLine: null,
        helperDragging: false
      }
    }
  },
  methods: {
    setHelperDraggingStatus(val, dir = 'verHelperLine') {
      this.states.helperDragging = val
      if (this.states[dir]) {
        this.states[dir].insideTargetElement = val
      }
    },
    isReadyDraging (column, dir = 'verHelperLine') {
      try {
        // 拖拽准备阶段
        return column.resizable !== false && (this.states.helperDragging || this.states[dir].insideTargetElement)
      } catch (error) {
        return false
      }
    },
    visibleHeplerLineNodeAnchor (val) {
      if (this.states.verHelperLine) {
        this.states.verHelperLine.visibleHeplerLineNodeAnchor(val)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/modules/helper-line.js